var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('ElTooltip',{staticClass:"mr-sm",attrs:{"content":_vm.error,"placement":"top"}},[_c('ExclamationIcon',{staticClass:"text-white bg-envelopeStatus-cancelled rounded-full h-base w-base p-xs",attrs:{"aria-hidden":"false","aria-invalid":_vm.error}})],1),_vm._v("\n\n  "+_vm._s(_vm.value)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }